import { connect } from "react-redux"
import SearchResults from "."

const mapStateToProps = ({ staticFilters, assetFilters }) => ({
  staticFilters,
  assetFilters,
})

const SearchResultsWithStore = connect(mapStateToProps)(SearchResults)
SearchResultsWithStore.propTypes = SearchResults.propTypes
export default SearchResultsWithStore
